import styled from 'styled-components';
import { Fade } from '~/styles/animations';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${(props) => props.theme.spacing.xSmall} 0;
  position: relative;

  span {
    font-size: 12px;
    color: #ed4343;
    margin: 2px;
    position: absolute;
    bottom: -6px;
    animation: ${Fade} linear forwards 0.5s;
  }

  label {
    margin-left: 2px;
    font-weight: normal;
    color: #2e384d;
    text-transform: uppercase;
  }

  input {
    border: 1px solid ${(props) => (props.error ? '#ED4343' : '#dfe3e8')};
    border-radius: 4px;
    outline: none;
    padding: ${(props) =>
      `${props.theme.spacing.xSmall} ${props.theme.spacing.small}`};
    font-size: 14px;
    width: 100%;
    transition: all ease 0.2s;

    &::placeholder {
      font-size: 14px;
      color: #6b7786;
    }
  }
`;
